export const clampPageToRowCount = ({
  currentPage,
  pageSize,
  totalRows
}: {
  currentPage: number;
  pageSize: number;
  totalRows: number;
}): number => {
  if (pageSize <= 0) return 0;

  const lastPage = Math.max(0, Math.ceil(totalRows / pageSize) - 1);

  return Math.min(currentPage, lastPage);
};
